<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view></router-view>
  </div>
</template>

<script>
// import Firebase from 'firebase'
//
// const config = {
//    apiKey: "AIzaSyCLE9AHpK5-OFDGfLZ8X0SxLh9XwR0nRxQ",
//    authDomain: "namefinder-936ee.firebaseapp.com",
//    databaseURL: "https://namefinder-936ee.firebaseio.com",
//    storageBucket: "namefinder-936ee.appspot.com",
//    messagingSenderId: "923738600597"
//  };
//
// let app = Firebase.initializeApp(config)
// let db = app.database()


export default {
  name: 'app',
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  margin: 10px 10px;
}
</style>



// WEBPACK FOOTER //
// App.vue?a3749cc6